

const router_modular = [
    {
        path: '/',
        redirect: '/home'
    },
    {
        path: '/home',
        name: 'landingPage',
        component: () => import('@/views/landingPage.vue')
    },
    {
        path: '/bankPage',
        name: 'bankPage',
        component: () => import('@/views/bankPage/index.vue')
    },
    {
        path: '/bankDetailsPage',
        name: 'bankDetailsPage',
        component: () => import('@/views/bankPage/bankDetailsPage.vue')   
    },
    {
        path: '/uploadCredentials',
        name: 'uploadCredentials',
        component: () => import(/* webpackChunkName: "uploadCredentials" */ '@/views/uploadCredentials/index.vue')
    },
    {
        path: '/enterInformation',
        name: 'enterInformation',
        component: () => import(/* webpackChunkName: "enterInformation/index.vue" */ '@/views/enterInformation/index.vue')
    },
    {
        path: '/repaymentResult',
        name: 'repaymentResult',
        component: () => import(/* webpackChunkName: "repaymentResult/index.vue" */ '@/views/repaymentResult/index.vue')
    },
    {
        path: '/commitRecord',
        name: 'commitRecord',
        component: () => import(/* webpackChunkName: "commitRecord/index.vue" */ '@/views/commitRecord/index.vue')
    },
    {
        path: '/privacyAgreement/col',
        name: 'privacyAgreementcol',
        component: () => import(/* webpackChunkName: "privacyAgreement/COL/index.vue" */ '@/views/privacyAgreement/COL/index.vue'),
        meta: {
           areaValue: "col"
        }
    },
    {
        path: '/serviceAgreement/col',
        name: 'serviceAgreementCOL',
        component: () => import(/* webpackChunkName: "serviceAgreement/COL/index.vue" */ '@/views/serviceAgreement/COL/index.vue'),
        meta: {
           areaValue: "col"
        }
    },
    {
        path: '/faq/col',
        name: 'faqcol',
        component: () => import(/* webpackChunkName: "FAQ/COL/index.vue" */ '@/views/FAQ/COL/index.vue'),
        meta: {
           areaValue: "col"
        }
    },
    {
        path: '/privacyAgreement/gtm',
        name: 'privacyAgreementgtm',
        component: () => import(/* webpackChunkName: "privacyAgreement/GTM/GTM.vue" */ '@/views/privacyAgreement/GTM/GTM.vue'),
        meta: {
           areaValue: "gtm"
        }
    },
    {
        path: '/serviceAgreement/gtm',
        name: 'serviceAgreementgtm',
        component: () => import(/* webpackChunkName: "serviceAgreement/GTM/GTM.vue" */ '@/views/serviceAgreement/GTM/GTM.vue'),
        meta: {
           areaValue: "gtm"
        }
    },
    {
        path: '/faq/gtm',
        name: 'faqgtm',
        component: () => import(/* webpackChunkName: "FAQ/GTM/GTM.vue" */ '@/views/FAQ/GTM/GTM.vue'),
        meta: {
           areaValue: "gtm"
        }   
    },
    {
        path: "/privacyAgreement/ago",
        name: "privacyAgreementago",
        component: () => import(/* webpackChunkName: "privacyAgreement/AGO/AGO.vue" */ '@/views/privacyAgreement/AGO/AGO.vue'),
        meta: {
            areaValue: 'ago'
        }
    },
    {
        path: '/serviceAgreement/ago',
        name: 'serviceAgreementago',
        component: () => import(/* webpackChunkName: "serviceAgreement/AGO/AGO.vue" */ '@/views/serviceAgreement/AGO/AGO.vue'),
        meta: {
           areaValue: "ago"
        }
    },
    {
        path: '/faq/ago',
        name: 'faqago',
        component: () => import(/* webpackChunkName: "FAQ/AGO/AGO.vue" */ '@/views/FAQ/AGO/AGO.vue'),
        meta: {
           areaValue: "ago"
        }   
    },
    {
        path: '/about_us',
        name: 'aboutUs',
        component: () => import('@/views/aboutUs/index.vue')
    },
]
export default router_modular